var map = {
	"./title-carousel.de-CH.json": 1196,
	"./title-carousel.de-DE.json": 1197,
	"./title-carousel.en-CA.json": 1198,
	"./title-carousel.en-GB.json": 1199,
	"./title-carousel.en-IN.json": 1200,
	"./title-carousel.en-ME.json": 1201,
	"./title-carousel.en-US.json": 1202,
	"./title-carousel.es-EM.json": 1203,
	"./title-carousel.es-ES.json": 1204,
	"./title-carousel.fr-BE.json": 1205,
	"./title-carousel.fr-CA.json": 1206,
	"./title-carousel.fr-CH.json": 1207,
	"./title-carousel.nl-BE.json": 1208,
	"./title-carousel.nl-NL.json": 1209,
	"./title-carousel.pl-PL.json": 1210,
	"./title-carousel.pt-BR.json": 1211
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1195;